import { useLocation } from "react-router-dom";
import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import HeroSlider from "../../wrappers/HeroSlider";
import { Container } from "react-bootstrap";
import { useState } from "react";
import { handleGlobalInputChange } from "../../helpers/functions";
import { apiInstance } from "../../helpers/axios";
import LoadingSpinner from "../../components/loading/LoadingSpinner";
import toast from "react-hot-toast";

const inputFields = [
  { name: "FullName", placeholder: "Full Name", type: "text" },
  { name: "CompanyName", placeholder: "Company Name", type: "text" },
  { name: "MobileNo", placeholder: "Mobile Number", type: "text" },
  { name: "Email", placeholder: "Email ID", type: "email" },
];

const initialState = {
  FullName: "",
  CompanyName: "",
  MobileNo: "",
  Email: "",
  Description: "",
};

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialState);
  let { pathname } = useLocation();

  const handleInputChange = (e) => handleGlobalInputChange(e, setFormData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await apiInstance.post("/Customer/ContactUs", formData);
      if (response.data.Status === true) {
        toast.success(response.data.Message);
        setFormData(initialState);
      } else {
        toast.error(response.data.Message);
      }
    } catch (error) {
      toast.error("Failed to send message. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      <SEO titleTemplate="Contact" description="Contact page" />
      <LayoutTwo>
        <HeroSlider />
        <Container>
          <Breadcrumb
            pages={[
              { label: "Home", path: "/" },
              { label: "Contact", path: pathname },
            ]}
          />
          <div className="contact-area pb-100 pt-50">
            <div className="container">
              <div className="custom-row-2">
                <div className="col-12 col-lg-4 col-md-5">
                  <div className="contact-info-wrap">
                    <div className="single-contact-info">
                      <div className="contact-icon">
                        <h4>GET IN TOUCH</h4>
                      </div>
                    </div>
                    <div className="single-contact-info">
                      <div className="contact-icon">Mumbai Sales:</div>
                      <div className="contact-info-dec">
                        <p>+91 98679 39900</p>
                        <p>sales@kalistajewels.com</p>
                      </div>
                    </div>
                    <div className="single-contact-info">
                      <div className="contact-icon">Surat Sales:</div>
                      <div className="contact-info-dec">
                        <p>+91 9819269900</p>
                        <p>sales@kalistajewels.com</p>
                      </div>
                    </div>
                    <div className="single-contact-info">
                      <div className="contact-icon">Marketing:</div>
                      <div className="contact-info-dec">
                        <p>+91 8849921690</p>
                        <p>marketing@kalistajewels.com</p>
                      </div>
                    </div>
                    <div className="single-contact-info">
                      <div className="contact-icon">
                        General Query <br /> (Surat)
                      </div>
                      <div className="contact-info-dec">
                        <p>0261-2402900</p>
                        <p>0261-2401900</p>
                      </div>
                    </div>
                    <div className="single-contact-info">
                      <div className="contact-icon">
                        General Query <br /> (Mumbai)
                      </div>
                      <div className="contact-info-dec">
                        <p>022-40113900</p>
                        <p>022-49236000</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-8 col-md-7">
                  <div className="contact-form">
                    <div className="contact-title mb-30">
                      <h2>Connect With Us</h2>
                    </div>
                    <form
                      className="contact-form-style"
                      onSubmit={handleSubmit}
                    >
                      <div className="row">
                        {inputFields.map((field, index) => (
                          <div className="col-lg-6" key={index}>
                            <input
                              name={field.name}
                              placeholder={field.placeholder}
                              type={field.type}
                              value={formData[field.name]}
                              onChange={handleInputChange}
                            />
                          </div>
                        ))}
                        <div className="col-lg-12">
                          <textarea
                            name="Description"
                            placeholder="Describe your requirements in Brief"
                            className="text-area"
                            value={formData.Description}
                            onChange={handleInputChange}
                          />
                          <button className="submit" type="submit">
                            SEND
                          </button>
                        </div>
                      </div>
                    </form>
                    <p className="form-message" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </LayoutTwo>
    </>
  );
};

export default Contact;
